import React, { useState, useEffect } from "react";
import { Button, Modal, ModalBody, ModalHeader } from 'reactstrap';
import { currencyFormat, roundOfTwoDecimal } from 'utils/columns';

import ReactStrapTable from "components/reactStrapTable";
import { dateFormate, cellRendererCheck } from "utils/columns";
import AccumulationDetails from "../AccumulationDetails";
import Drawer from "components/Drawer";
import ColumnFilters from "components/reactStrapTable/components/ColumnFilters";
import UnitsDispensed from "../UnitsDispensed";
import UnitsReplenished from "../UnitsReplenished";
import EyeIcon from 'assets/icon/icon-icon-options-view-patient.svg';
import EyeIconHover from 'assets/icon/icon-icon-options-view-patient_hover.svg';
import HoverImage from "react-hover-image/build";
import DragDrop from "components/DragDrop";
import useAxios from "hooks/useAxios";
import { onExport } from "utils/helper";
import { ModuleAccess } from "utils/moduleaccess";
import useContextService from "hooks/useContextService";


let modulename = "Inventory";
let autoselectlist1 = [];
let currencylist = [];
let dateList = ['Last Accumulation Date', 'Last Purchase Date'];
let numberlist = ['Adjustments', 'Accumulations', 'Pending', 'Purchases']
let widthForCEandP = ['Covered Entity','Pharmacy',"Drug Name" ]
let hideColFilterlist = ['Accumulations', 'Adjustments', 'Pending','Purchases', 'Last Purchase Date' ]
let tableDataBackup = [];
let width170 = ["340B Balance Packages" ,"340B Balance"] ;
let isRole = ["GWPHA", "GWPHU"]    
const InventoryTable = ({
  tenantID,
  data,
  loading,
  AllExport,
  slelectedExportcoloumms,
  filters,
  totalSize,
  toggleSider,
  collapseSider,
  onPageChange,
  refetch,
  setLoading,
  onSearchColumnFilters,
  thirdPartyAdmin,
  reset,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [hasExportPermission, setHasExportPermission] = useState(false);
  const [drawer, setDrawer] = useState('');
  const [isDispensedOpen, setisDispensedOpen] = useState(false);
  const [drawerDispensed, setDrawerDispensed] = useState('');
  const [isReplenishedOpen, setisReplenishedOpen] = useState(false);
  const [rowDataBackup , setRowDataBackup] = useState({}) ;
  const [disableSelectedColumn, setDisableSelectedColumn] = useState(false);
  const { token_type, access_token, profile } =
    JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
  const [drawerReplenished, setDrawerReplenished] = useState('');
  const [accRowData, setAccRowData] = useState({});
  const [state, updateState] = useState({
    tableData: [],
    backUpData: [],
    filters: filters,
  });
  const API = useAxios();

  const {
    states: { Inventory },
    setStates,
    resetStates,
  } = useContextService();
  const { search, searchTerms } =
    Inventory;
  const { ceIds, pharmacyids } =
    searchTerms;
  const { roles } = profile || {};
  console.log(roles, "roles")
  var con = isRole.includes(roles);
  const [tableData, setTableData] = useState(tableDataBackup);
  const [coloumselect, setColoumselect] = useState(false);
  const [hasToRest , setHasToRest] = useState(false) ; // refetchs the main table when the value becomes true .
  const handleselectColoums = () => {
    setColoumselect(!coloumselect);
  }
  useEffect(() => {
    setHasExportPermission(ModuleAccess("INV", "EXP"));
  }, []);
  useEffect(() => {
    handlAutocoloms();
  }, []);
  const handlAutocoloms = async () => {

    autoselectlist1 = [];
    try {
      const { data } = await API.get(`GWConfig/coveredentity/autoselectcoloumslist/${modulename}`, {
        hasDefaultURL: true,
      });
      if (data) {
        if (data.length > 0) {
          setDisableSelectedColumn(false);
        } else {
          setDisableSelectedColumn(true);
        }
        for (var x in data) {
          autoselectlist1.push({ "text": data[x].displayName, "dataField": data[x].fieldName });

        }
      }

    } catch (err) {

    }
  }
  useEffect(() => {
    setState({ tableData: data, backUpData: data });
  }, [data]);
  const setState = (obj) => updateState(pre => ({ ...pre, ...obj }));

  useEffect(() => {
    setState({ filters: filters });
  }, [filters]);
  useEffect(() => {
    setTableData(data);
    tableDataBackup = data;
  }, [data]);

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      setState({
        filters: filter,
      });
      let colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    setState({
      filters: filter,
    });
    onPageChange(filter);
  };

  const handleFilterCancel = () => {
    refetch(true);
  };
  const handleSearchColumnFilters = (colFilter) => {
    if (onSearchColumnFilters) {
      const filter = { ...state.filters, filters: colFilter, currentPage: 1 };
      onSearchColumnFilters(filter);
      setState({
        filters: filter,
      });
    }
  };


  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      setState({
        filters: filter,
      });
      let colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      setState({
        filters: filter,
      });
      onPageChange(filter);
    }
  };

  const handleSort = (filter, hasColFilter) => {
    setState({
      filters: filter,
    });
    if (hasColFilter) {
      onPageChange(filter, true);
    } else {
      onPageChange(filter);
    }
  };

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
    setDrawer('');
  };

  const drawerClose = (hasUpdated) => {
    setIsOpen(!isOpen);
    setDrawer('');
    if (hasUpdated) refetch();
  };
  const handleNdc = (row) => {
    setIsOpen(!isOpen);
    setDrawer('ndc');
    setAccRowData(row);
    setRowDataBackup({'ndc' : row.ndc , 'opaCode' : row.opaCode , 'npi' : row.npi})
  };

  useEffect(() => {

     var lst = {};
        lst = rowDataBackup ;
        let filterdRow = data.find(m => m.ndc == lst.ndc && m.opaCode == lst.opaCode && m.npi == lst.npi);
        setAccRowData(filterdRow);

    if (hasToRest == true) {
      setHasToRest(false);
      refetch();
        var lst = {};
        lst = rowDataBackup ;
        let filterdRow = data.find(m => m.ndc == lst.ndc && m.opaCode == lst.opaCode && m.npi == lst.npi);
        setAccRowData(filterdRow);

    }
  }, [hasToRest, data])

      // console.log(accRowData);

  
  const toggleDispensedDrawer = () => {
    setisDispensedOpen(!isDispensedOpen);
    setDrawerDispensed('');
  };

  const drawerDispensedClose = (hasUpdated) => {
    setisDispensedOpen(!isDispensedOpen);
    setDrawerDispensed('');
    if (hasUpdated) refetch();
  };
  const handleUnitsDispensed = (row) => {
    setisDispensedOpen(!isDispensedOpen);
    setDrawerDispensed('Dispensed');
    setAccRowData(row);
  };
  const toggleReplenishedDrawer = () => {
    setisReplenishedOpen(!isReplenishedOpen);
    setDrawerReplenished('');
  };

  const drawerReplenishedClose = (hasUpdated) => {
    setisReplenishedOpen(!isReplenishedOpen);
    setDrawerReplenished('');
    if (hasUpdated) refetch();
  };
  const handleUnitsReplenished = (row) => {
    setisReplenishedOpen(!isReplenishedOpen);
    setDrawerReplenished('Replenished');
    setAccRowData(row);
  };

  // const cellRendererNDC = (row) => {
  //   const { ndc } = row;
  //   if (ndc) {
  //     return (
  //       <span
  //         className='cursor-pointer text-decoration-underline'
  //         onClick={() => handleNdc(row)}
  //       >
  //         {ndc}
  //       </span>
  //     );
  //   }
  //   return '-';
  // };

  const cellRendererUnitsReplenished = (row) => {
    const { orderedUnits } = row;
    if (orderedUnits) {
      return (
        <span
          className='cursor-pointer text-decoration-underline'
          onClick={() => handleUnitsReplenished(row)}
        >
          {orderedUnits}
        </span>
      );
    }
    return '-';
  };

  const cellRendererUnitsDispensed = (row) => {
    const { accumulations } = row;
    if (accumulations) {
      return (
        <span
          className='cursor-pointer text-decoration-underline'
          onClick={() => handleUnitsDispensed(row)}
        >
          {accumulations}
        </span>
      );
    }
    return '-';
  };
  const cellRenderView = (row) => {
    return (
      <div className='d-flex align-items-center'>
        <Button
          className='text-primary p-0 text-decoration-none'
          color='link'
          onClick={() => handleNdc(row)}
        >
          <HoverImage
            key='EyeIcon'
            src={EyeIcon}
            hoverSrc={EyeIconHover}
            alt=''
          />
        </Button>
      </div>
    )
  }



  const cellRenderLink = (rowData) => {
    return (
      <span
        className='text-decoration-underline d-inline-block cursor-pointer'
      //onClick={() => handlePODetails(rowData)}
      >
        {rowData.poid}
      </span>
    );
  };
  const cellOptionLink = (rowData) => {
    if (rowData.poStatusID == 5070) {
      return (
        <Button color='link' onClick={() => handleClaimsPO(rowData)}>
          <HoverImage src={ViewClaimsHover} hoverSrc={ViewClaimsHover} alt />
        </Button>
      );
    }

  };
  const onHandleSort = (filter, hasColFilter) => {
    if (hasColFilter) {
      onPageChange(filter, true);
    } else {
      onPageChange(filter);
    }
  };
  const { addOrderModal } = state;
  let maincol1 = [
    { 
      dataField: 'options',
      text: 'Options',
      sort: false,
      width: 100,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellRenderView(rowData),
      action: true,
      hideColFilter : false
    },
    {
      dataField: autoselectlist1[0]?.dataField,
      text: autoselectlist1[0]?.text,
      cellRenderer: autoselectlist1[0]?.text == "340B Accumulation Packages" ? (rowData) => roundOfTwoDecimal(rowData.balancePackages) : currencylist.includes(autoselectlist1[0]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[0]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[0]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 0 ? true : false,
      inputType: dateList.includes(autoselectlist1[0]?.text) ? "date" : numberlist.includes(autoselectlist1[0]?.text) ? "number" : "text",
      width: widthForCEandP.includes(autoselectlist1[0]?.text) ? 288 : width170.includes(autoselectlist1[0]?.text) ? 170 : 144,
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[0]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[0]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[1]?.dataField,
      text: autoselectlist1[1]?.text,
      cellRenderer: autoselectlist1[1]?.text == "340B Accumulation Packages" ? (rowData) => roundOfTwoDecimal(rowData.balancePackages) : currencylist.includes(autoselectlist1[1]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[1]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[1]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width: widthForCEandP.includes(autoselectlist1[1]?.text) ? 288 : width170.includes(autoselectlist1[1]?.text) ? 170 : 144,
      show: autoselectlist1.length > [1] ? true : false,
      inputType: dateList.includes(autoselectlist1[1]?.text) ? "date" : numberlist.includes(autoselectlist1[1]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[1]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[1]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[2]?.dataField,
      text: autoselectlist1[2]?.text,
      cellRenderer: autoselectlist1[2]?.text == "340B Accumulation Packages" ? (rowData) => roundOfTwoDecimal(rowData.balancePackages) : currencylist.includes(autoselectlist1[2]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[2]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[2]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [2] ? true : false,
      inputType: dateList.includes(autoselectlist1[2]?.text) ? "date" : numberlist.includes(autoselectlist1[2]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[2]?.text) ? true : false,
      width: widthForCEandP.includes(autoselectlist1[2]?.text) ? 288 : width170.includes(autoselectlist1[2]?.text) ? 170 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[2]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[3]?.dataField,
      text: autoselectlist1[3]?.text,
      cellRenderer: autoselectlist1[3]?.text == "340B Accumulation Packages" ? (rowData) => roundOfTwoDecimal(rowData.balancePackages) : currencylist.includes(autoselectlist1[3]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[3]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[3]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [3] ? true : false,
      inputType: dateList.includes(autoselectlist1[3]?.text) ? "date" : numberlist.includes(autoselectlist1[3]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[3]?.text) ? true : false,
      action: true,
      width: widthForCEandP.includes(autoselectlist1[3]?.text) ? 288 : width170.includes(autoselectlist1[3]?.text) ? 170 : 144,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[3]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[4]?.dataField,
      text: autoselectlist1[4]?.text,
      cellRenderer: autoselectlist1[4]?.text == "340B Accumulation Packages" ? (rowData) => roundOfTwoDecimal(rowData.balancePackages) : currencylist.includes(autoselectlist1[4]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[4]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[4]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width: widthForCEandP.includes(autoselectlist1[4]?.text) ? 288 : width170.includes(autoselectlist1[4]?.text) ? 170 : 144,
      show: autoselectlist1.length > [4] ? true : false,
      inputType: dateList.includes(autoselectlist1[4]?.text) ? "date" : numberlist.includes(autoselectlist1[4]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[4]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[4]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[5]?.dataField,
      text: autoselectlist1[5]?.text,
      cellRenderer: autoselectlist1[5]?.text == "340B Accumulation Packages" ? (rowData) => roundOfTwoDecimal(rowData.balancePackages) : currencylist.includes(autoselectlist1[5]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[5]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[5]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [5] ? true : false,
      inputType: dateList.includes(autoselectlist1[5]?.text) ? "date" : numberlist.includes(autoselectlist1[5]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[5]?.text) ? true : false,
      width: widthForCEandP.includes(autoselectlist1[5]?.text) ? 288 : width170.includes(autoselectlist1[5]?.text) ? 170 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[5]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[6]?.dataField,
      text: autoselectlist1[6]?.text,
      cellRenderer: autoselectlist1[6]?.text == "340B Accumulation Packages" ? (rowData) => roundOfTwoDecimal(rowData.balancePackages) : currencylist.includes(autoselectlist1[6]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[6]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[6]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [6] ? true : false,
      inputType: dateList.includes(autoselectlist1[6]?.text) ? "date" : numberlist.includes(autoselectlist1[6]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[6]?.text) ? true : false,
      width: widthForCEandP.includes(autoselectlist1[6]?.text) ? 288 : width170.includes(autoselectlist1[6]?.text) ? 170 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[6]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[7]?.dataField,
      text: autoselectlist1[7]?.text,
      cellRenderer: autoselectlist1[7]?.text == "340B Accumulation Packages" ? (rowData) => roundOfTwoDecimal(rowData.balancePackages) : currencylist.includes(autoselectlist1[7]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[7]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[7]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [7] ? true : false,
      inputType: dateList.includes(autoselectlist1[7]?.text) ? "date" : numberlist.includes(autoselectlist1[7]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[7]?.text) ? true : false,
      width: widthForCEandP.includes(autoselectlist1[7]?.text) ? 288 : width170.includes(autoselectlist1[7]?.text) ? 170 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[7]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[8]?.dataField,
      text: autoselectlist1[8]?.text,
      cellRenderer: autoselectlist1[8]?.text == "340B Accumulation Packages" ? (rowData) => roundOfTwoDecimal(rowData.balancePackages) : currencylist.includes(autoselectlist1[8]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[8]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[8]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [8] ? true : false,
      inputType: dateList.includes(autoselectlist1[8]?.text) ? "date" : numberlist.includes(autoselectlist1[8]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[8]?.text) ? true : false,
      action: true,
      width: widthForCEandP.includes(autoselectlist1[8]?.text) ? 288 : width170.includes(autoselectlist1[8]?.text) ? 170 : 144,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[8]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[9]?.dataField,
      text: autoselectlist1[9]?.text,
      cellRenderer: autoselectlist1[9]?.text == "340B Accumulation Packages" ? (rowData) => roundOfTwoDecimal(rowData.balancePackages) : currencylist.includes(autoselectlist1[9]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[9]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[9]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width: 80,
      show: autoselectlist1.length > [9] ? true : false,
      inputType: dateList.includes(autoselectlist1[9]?.text) ? "date" : numberlist.includes(autoselectlist1[9]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[9]?.text) ? true : false,
      width: widthForCEandP.includes(autoselectlist1[9]?.text) ? 288 : width170.includes(autoselectlist1[9]?.text) ? 170 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[9]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[10]?.dataField,
      text: autoselectlist1[10]?.text,
      cellRenderer: autoselectlist1[10]?.text == "340B Accumulation Packages" ? (rowData) => roundOfTwoDecimal(rowData.balancePackages) : currencylist.includes(autoselectlist1[10]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[10]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[10]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width: widthForCEandP.includes(autoselectlist1[10]?.text) ? 288 : width170.includes(autoselectlist1[10]?.text) ? 170 : 144,
      show: autoselectlist1.length > [10] ? true : false,
      inputType: dateList.includes(autoselectlist1[10]?.text) ? "date" : numberlist.includes(autoselectlist1[10]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[10]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[10]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[11]?.dataField,
      text: autoselectlist1[11]?.text,
      cellRenderer: autoselectlist1[11]?.text == "340B Accumulation Packages" ? (rowData) => roundOfTwoDecimal(rowData.balancePackages) : currencylist.includes(autoselectlist1[11]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[11]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[11]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [11] ? true : false,
      inputType: dateList.includes(autoselectlist1[11]?.text) ? "date" : numberlist.includes(autoselectlist1[11]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[11]?.text) ? true : false,
      width: widthForCEandP.includes(autoselectlist1[11]?.text) ? 288 : width170.includes(autoselectlist1[11]?.text) ? 170 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[11]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[12]?.dataField,
      text: autoselectlist1[12]?.text,
      cellRenderer: autoselectlist1[12]?.text == "340B Accumulation Packages" ? (rowData) => roundOfTwoDecimal(rowData.balancePackages) : currencylist.includes(autoselectlist1[12]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[12]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[12]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [12] ? true : false,
      inputType: dateList.includes(autoselectlist1[12]?.text) ? "date" : numberlist.includes(autoselectlist1[12]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[12]?.text) ? true : false,
      width: widthForCEandP.includes(autoselectlist1[12]?.text) ? 288 : width170.includes(autoselectlist1[12]?.text) ? 170 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[12]?.text) ? true : false,

    },
    {
      dataField: autoselectlist1[13]?.dataField,
      text: autoselectlist1[13]?.text,
      cellRenderer: autoselectlist1[13]?.text == "340B Accumulation Packages" ? (rowData) => roundOfTwoDecimal(rowData.balancePackages) : currencylist.includes(autoselectlist1[13]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[13]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[13]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width: widthForCEandP.includes(autoselectlist1[13]?.text) ? 288 : width170.includes(autoselectlist1[13]?.text) ? 170 : 144,
      show: autoselectlist1.length > [13] ? true : false,
      inputType: dateList.includes(autoselectlist1[13]?.text) ? "date" : numberlist.includes(autoselectlist1[13]?.text) ? "number" : "text",

      hideColFilter: !hideColFilterlist.includes(autoselectlist1[13]?.text) ? true : false,

      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[13]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[14]?.dataField,
      text: autoselectlist1[14]?.text,
      cellRenderer: autoselectlist1[14]?.text == "340B Accumulation Packages" ? (rowData) => roundOfTwoDecimal(rowData.balancePackages) : currencylist.includes(autoselectlist1[14]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[14]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[14]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width: widthForCEandP.includes(autoselectlist1[14]?.text) ? 288 : width170.includes(autoselectlist1[14]?.text) ? 170 : 144,
      show: autoselectlist1.length > [14] ? true : false,
      inputType: dateList.includes(autoselectlist1[14]?.text) ? "date" : numberlist.includes(autoselectlist1[14]?.text) ? "number" : "text",

      hideColFilter: !hideColFilterlist.includes(autoselectlist1[14]?.text) ? true : false,

      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[14]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[15]?.dataField,
      text: autoselectlist1[15]?.text,
      cellRenderer: autoselectlist1[15]?.text == "340B Accumulation Packages" ? (rowData) => roundOfTwoDecimal(rowData.balancePackages) : currencylist.includes(autoselectlist1[15]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[15]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[15]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [15] ? true : false,
      inputType: dateList.includes(autoselectlist1[15]?.text) ? "date" : numberlist.includes(autoselectlist1[15]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[15]?.text) ? true : false,
      width: widthForCEandP.includes(autoselectlist1[15]?.text) ? 288 : width170.includes(autoselectlist1[15]?.text) ? 170 : 144,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[15]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[16]?.dataField,
      text: autoselectlist1[16]?.text,
      cellRenderer: autoselectlist1[16]?.text == "340B Accumulation Packages" ? (rowData) => roundOfTwoDecimal(rowData.balancePackages) : currencylist.includes(autoselectlist1[16]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[16]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[16]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width: widthForCEandP.includes(autoselectlist1[16]?.text) ? 288 : width170.includes(autoselectlist1[16]?.text) ? 170 : 144,
      show: autoselectlist1.length > [16] ? true : false,
      inputType: dateList.includes(autoselectlist1[16]?.text) ? "date" : numberlist.includes(autoselectlist1[16]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[16]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideColFilterlist.includes(autoselectlist1[16]?.text) ? true : false,
    },
  ];
  let mainCol = [
    {
      dataField: 'options',
      text: 'Options',
      sort: false,
      width: 100,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellRenderView(rowData),
      action: true,
      hideColFilter: true,
    },

    {
      dataField: 'coveredEntityName',
      text: 'Covered Entity',
      sort: false,
      width: 288 ,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    // {
    //   dataField: 'opaCode',
    //   text: '340B ID',
    //   sort: false,
    //   width: 140,
    //   show: true,
    //   inputType: 'text',
    //   hideColFilter: true,
    //   cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    // },
    {
      dataField: 'pharmacyName',
      text: 'Pharmacy',
      sort: false,
      width: 288 ,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: 'npi',
      text: 'Pharmacy NPI',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: "ndc" ,
      text: "NDC",
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: "drugName",
      text: "Drug Name",
      sort: false,
      width: 220,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: "drugManufacturerName",
      text: "Manufacturer",
      sort: false,
      width: 180,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: "packageSize",
      text: "Package Size",
      sort: false,
      width: 144,
      show: true,
      inputType: 'number',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: "brandGenericFlag",
      text: "Brand or Generic",
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: 'accumulations',
      text: 'Accumulations',
      sort: true,
      width: 144,
      show: true,
      inputType: 'number',
      hideColFilter: false,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: 'adjustmentUnits',
      text: 'Adjustments',
      sort: true,
      width: 144,
      show: true,
      inputType: 'number',
      hideColFilter: false,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData.adjustmentUnits),
    },
    {
      dataField: 'onOrderedUnits',
      text: 'Pending',
      sort: true,
      width: 144,
      show: true,
      inputType: 'number',
      hideColFilter: false,
      cellRenderer: (rowData) => cellRendererCheck(rowData.onOrderedUnits),
    },
    {
      dataField: 'orderedUnits',
      text: 'Purchases',
      sort: true,
      width: 144,
      show: true,
      inputType: 'number',
      hideColFilter: false,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: "balance",
      text: "340B Balance",
      sort: false,
      width: 170,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: "balancePackages",
      text: "340B Balance Packages",
      sort: false,
      width: 170,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData) => roundOfTwoDecimal(rowData.balancePackages),
    },
    {
      dataField: "modifiedDate",
      text: "Last Accumulation Date",
      sort: false,
      width: 144,
      show: true,
      inputType: 'date',
      hideColFilter: true,
      cellRenderer: (rowData) => dateFormate(rowData.modifiedDate),
    },
    {
      dataField: "lastPurchaseDate",
      text: "Last Purchase Date",
      sort: true,
      width: 144,
      show: true,
      inputType: 'date',
      hideColFilter: false,
      cellRenderer: (rowData) => dateFormate(rowData.lastPurchaseDate),
    },
  ];
  const { detailDrawer } = state;

  const toggleDetailDrawer = (rowData) => {
    setAccRowData(rowData);
    setState({
      detailDrawer: !detailDrawer,
    });
  };

  const { filters: colFilter, backUpData } = state;
  console.log(autoselectlist1, "autoselectlist1")
  return (
    <div>
    <h5 className="f-16 text-primary font-weight-700">
      Accumulations Count ({totalSize})
    </h5>
    <hr />
    <div
      className="table-card scroll-table position-relative border-0 rounded pt-0"
      fixed-height={data.length > 0 ? "fixed-height" : "default"}
    >
      <ReactStrapTable
        id='inventory-table'
        height={550}
        fixedColumn
        width={1200}
        // reset={reset}
        hasPagination
        loading={loading}
        data={tableData}
        columns={autoselectlist1.length > 0 ? maincol1 : mainCol}
        AllExport={AllExport}
        slelectedExport={slelectedExportcoloumms}
        filters={filters}
        totalRecords={totalSize}
        pageSize={filters.pageSize}
        currentPage={filters.currentPage}
        handleSort={onHandleSort}
        onPageChange={onHandlePageChange}
        onPageSizeChange={onPageSizeChange}
        onFilterCancel={handleFilterCancel}
        onSearchColumnFilters={handleSearchColumnFilters}
        hasColselect={true}
        onSelectColoums={handleselectColoums}
        hasExportPermission={hasExportPermission}
        disableSelectedColumn={disableSelectedColumn}
        autoselectlist1={autoselectlist1}
        collapseSider={collapseSider}
        enabletogglesider={true}
        toggleSider={toggleSider}
        >
      </ReactStrapTable>

      <Modal
        isOpen={coloumselect}
        toggle={handleselectColoums}
        size='lg'
        className='lg'
      >
        <ModalHeader toggle={handleselectColoums}>
          Column Selector
        </ModalHeader>
        <ModalBody>
          <DragDrop cancalcolselect={handleselectColoums} refetch={handleselectColoums} reloadautocolum={handlAutocoloms} modulename={modulename} />
        </ModalBody>
      </Modal>


      <Drawer
        direction="end"
        title="Accumulation Details"
        isOpen={isOpen}
        toggle={toggleDrawer}
        size="lg"
      >
        <AccumulationDetails tenantID={tenantID} rowData={accRowData} refetch={refetch} setHasToRest = {setHasToRest}  onClose={drawerClose} />

      </Drawer>
      <Drawer
        direction="end"
        title="Units Dispensed"
        isOpen={isDispensedOpen}
        toggle={toggleDispensedDrawer}
        size="lg"
      >
        <UnitsDispensed tenantID={tenantID} rowData={accRowData}
          onClose={drawerDispensedClose} />
      </Drawer>
      <Drawer
        direction="end"
        title="Units Replenished"
        isOpen={isReplenishedOpen}
        toggle={toggleReplenishedDrawer}
        size="lg"
      >
        <UnitsReplenished tenantID={tenantID} rowData={accRowData}
          onClose={drawerReplenishedClose} />
      </Drawer>

    </div>
    </div>
  );
};

export default InventoryTable;